class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeDelay = 250; // ms delay before closing menu
    this.closeTimeout = null;

    // Desktop: hover to open/close menu with delay
    this.setupHoverBehavior();

    // Desktop: allow clicks on summary to follow link
    this.setupClickBehavior();
  }

  setupHoverBehavior() {
    const summary = this.mainDetailsToggle.querySelector('summary');

    // Open on mouseenter
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      // Clear any pending close timeout
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
      this.open();
    });

    // Close on mouseleave with delay
    this.mainDetailsToggle.addEventListener('mouseleave', () => {
      this.closeTimeout = setTimeout(() => {
        this.close();
      }, this.closeDelay);
    });
  }

  setupClickBehavior() {
    const summary = this.mainDetailsToggle.querySelector('summary');

    // Allow click to follow link - get the link URL from Shopify navigation
    summary.addEventListener('click', (event) => {
      // Get the parent link data if available
      const linkUrl = summary.dataset.href || summary.closest('[data-href]')?.dataset.href;

      if (linkUrl && linkUrl !== '#' && linkUrl !== '') {
        // Navigate to the link
        window.location.href = linkUrl;
      }
      // If no link URL, prevent default toggle behavior (hover handles open/close)
      event.preventDefault();
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
